//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  emits: [
    'change',
  ],
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // тяну из _slug для вычисления "левый / правый глаз"
    selectedVariants: {
      type: Array,
      default: null,
    },
    parentVariantIndex: {
      type: Number | String,
      default: null,
    },
    available: {
      type: Boolean,
      default: false
    },
    prevGroupName: {
      type: String,
      default: ''
    },

    refOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    groupIdx: {}
  },

  data() {
    return {
      selectedOption: null,
      isShowMore: false,
    }
  },

  watch: {
    available: function () {
      if (this.available) {
        this.initFirstItem();
      }
    },
    selectedItem: function (current, old) {
      if (!!current && !old && this.available) {
        this.initItemFromSelected();
      }
    },
  },

  methods: {
    initFirstItem: function () {
      if (this.variantsValue.length === 1 && !this.selectedItem) {
        this.selectOpticOption(this.variantsValue?.[0]);
      }
    },
    initItemFromSelected: function () {
      const selectedVariant = this.selectedVariants?.[this.parentVariantIndex] || {};
      const selectedItem = selectedVariant?.[this.item?.groupId];
      const selectedOption = (this.item?.variants || []).find((t) => Boolean(String(t.id) === String(selectedItem?.id)));
      this.selectedOption = selectedOption || null;
    },

    changeMoreFromRef: function (_val) {
      this.isShowMore = _val;
    },

    selectOpticOption(option) {
      if (this.available) {
        this.selectedOption = option;
        this.$emit('change', option)
      } else return false
    },
    // реализация переключения по 1 кнопке элемнета сразу для двух глаз
    toggleShowMoreVariants() {
      const _newVal = !this.isShowMore;

      const functionChangeVal = (refItem, value) => {
        if (!refItem) {
          return null
        }

        const childElement = (refItem.$children || []).find((t) => t.prevGroupName === this.prevGroupName);
        if (!childElement) {
          return null
        }

        childElement.changeMoreFromRef(value);
      };
      functionChangeVal((this.refOptions?.refOption0?.[0] || this.refOptions?.refOption0 || null), _newVal);
      functionChangeVal((this.refOptions?.refOption1?.[0] || this.refOptions?.refOption1 || null), _newVal);
    },
    // проверка состояние соседнего элемента, для разворчаивания второго при переключении вкладки на 2 глаза
    checkShowIsMoreFirstChild: function() {
      const functionChangeVal = (refItem) => {
        if (!refItem) {
          return null
        }

        const childElement = (refItem.$children || []).find((t) => t.prevGroupName === this.prevGroupName);
        if (!childElement) {
          return null
        }

        childElement.changeMoreFromRef();
      };
      functionChangeVal((this.refOptions?.refOption0?.[0] || this.refOptions?.refOption0 || null));
      functionChangeVal((this.refOptions?.refOption1?.[0] || this.refOptions?.refOption1 || null));
    }
  },

  computed: {
    selectedItem: function () {
      const selectedVariant = this.selectedVariants?.[this.parentVariantIndex] || {};
      const selectedItem = selectedVariant?.[this.item?.groupId];
      return selectedItem?.label || ""
    },

    variantsValue() {
      if (this.item.variants.length > 20 && !this.isShowMore) {
        let _items = [...(this.item.variants)];
        let indexActive = _items.findIndex((t) => Boolean(String(this.selectedOption?.id) === String(t.id)));
        if (indexActive > 20) {
          return [
            ...(_items.slice(0, 19)),
            _items[indexActive]
          ]
        }
        return this.item.variants.slice(0, 20);
      }

      return this.item.variants;
    },
  },

  mounted: function() {
    this.checkShowIsMoreFirstChild();
  }
}
